import { message } from "antd";

// Endpoints that must NOT trigger the session-expired flow on 401/403
// (e.g. wrong password on the login form should stay on the login screen).
const AUTH_EXEMPT_PATHS = ["auth/login"];

let sessionExpiredHandled = false;

const isAuthExempt = (url = "") =>
  AUTH_EXEMPT_PATHS.some((path) => url.includes(path));

export const handleSessionExpired = () => {
  if (sessionExpiredHandled) return;
  sessionExpiredHandled = true;

  try {
    message.warning("Your session has expired. Please log in again.");
  } catch (e) {
    // antd message can fail in non-DOM contexts; swallow and continue.
  }

  localStorage.clear();

  // Send the user back to the root; App.js will render <SignIn /> because
  // isLoggedIn is derived from localStorage.userData, which is now gone.
  window.location.href = "/";
};

// Attaches a response interceptor that forces logout on auth failures.
// Safe to call on the default axios export or on any axios.create() instance.
export const attachAuthInterceptor = (axiosInstance) => {
  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;
      const requestUrl = error?.config?.url || "";

      if ((status === 401 || status === 403) && !isAuthExempt(requestUrl)) {
        handleSessionExpired();
      }

      return Promise.reject(error);
    }
  );
};
